import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromCustomerUsers from './state/customer-users.reducer';
import { CustomerUsersEffects } from './state/customer-users.effects';

@NgModule({
    imports: [
        StoreModule.forFeature(
            fromCustomerUsers.CUSTOMERUSERS_FEATURE_KEY,
            fromCustomerUsers.reducer
        ),
        EffectsModule.forFeature([CustomerUsersEffects]),
    ],
})
export class HubAdministrationCustomerUsersStateModule {}
